import React, { useMemo } from "react";
import { Header } from "../../Header";
import { Icon } from "@iconify/react";
import Transactions from ".";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const TransactionsWrapper = () => {
  const location = useLocation();
  const { recentTransactions, isLoadingRecentTransactions } = useSelector(
    (state) => state.wallet
  );

  const searchParams = new URLSearchParams(location.search);
  const orderId = searchParams.get("order_id");

  // Apply order_id filter
  const filteredTransactions = useMemo(
    () =>
      recentTransactions.filter((tx) =>
        orderId ? +tx.service_order_id === +orderId : true
      ),
    [orderId, recentTransactions]
  );

  return (
    <>
      <Header
        pageTitle={`Transactions > Order ID : ${orderId}`}
        icon={
          <Icon icon="material-symbols-light:account-balance-wallet-outline" />
        }
      />
      {isLoadingRecentTransactions ? (
        <p className="text-center py-4">Loading transactions...</p>
      ) : filteredTransactions.length === 0 ? (
        <p className="text-center py-4">No transactions found.</p>
      ) : (
        <Transactions transactions={filteredTransactions} />
      )}
    </>
  );
};

export default TransactionsWrapper;
